import React from 'react';
import PropTypes from 'prop-types';
import Comments from 'src/components/Comments';

const getComments = (comments) => {
  return comments.map(
    (comment) => ({ ...comment, createdBy:  'NSD' })
  );
};

const AuthorDateTimeComments = ({ comments }) => {
  return (
    <Comments comments={getComments(comments)} />
  );
};

AuthorDateTimeComments.propTypes = {
  comments: PropTypes.array
};

export default AuthorDateTimeComments;
